import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";

const SERVICES = [
  {
    title: "Hospital Consultancy",
    desc: "Practical support for healthcare institutions looking to strengthen processes, coordination and healthcare business operations.",
    cta: "Discuss Your Requirement",
  },
  {
    title: "Insurance & TPA Support",
    desc: "Support and process awareness related to hospital insurance desks, TPA coordination and healthcare insurance processes.",
    cta: "Learn More",
  },
  {
    title: "Cashless Process Support",
    desc: "Helping hospital teams understand and organize cashless-related processes, documentation and coordination.",
    cta: "Explore Cashless Support",
  },
  {
    title: "Hospital Empanelment Support",
    desc: "Professional assistance and process guidance for hospitals exploring empanelment opportunities with relevant healthcare insurance and TPA networks.",
    cta: "Talk To Our Team",
  },
  {
    title: "Healthcare Staff Training",
    desc: "Practical training initiatives for hospital teams covering areas such as insurance processes, cashless desk operations, documentation awareness, communication and healthcare administration.",
    cta: "Request Training Information",
  },
  {
    title: "Healthcare Business & Networking",
    desc: "Building professional connections between healthcare institutions, professionals and other relevant healthcare-sector stakeholders.",
    cta: "Build a Connection",
  },
  {
    title: "Certification & Accreditation Support",
    desc: "Process guidance and preparation support for hospitals exploring relevant healthcare certifications and accreditations.",
    cta: "Discuss Accreditation",
  },
  {
    title: "Healthcare Audits",
    desc: "Structured review support for hospital processes, documentation, insurance desks and operational workflows.",
    cta: "Plan an Audit",
  },
  {
    title: "Reimbursement Support",
    desc: "Helping hospital teams understand and organize reimbursement-related processes, documentation and follow-ups.",
    cta: "Get Reimbursement Support",
  },
  {
    title: "Claim Rejection Support",
    desc: "Helping hospitals and individuals understand health and insurance claim rejection reasons and the general steps available to address them.",
    cta: "Understand Your Options",
  },
  {
    title: "Grievance Handling & Escalation",
    desc: "Process guidance for handling healthcare and insurance-related grievances and understanding the appropriate escalation channels.",
    cta: "Talk To Us",
  },
];

export const Services = () => (
  <section id="services" className="relative bg-[#EAF3F8] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionTag index="04" label="Our Services" />
        <h2 className="font-display mt-6 max-w-3xl text-2xl font-bold tracking-tight text-[#0B3C5C] sm:text-3xl lg:text-4xl">
          Healthcare Solutions for a Changing Healthcare Ecosystem
        </h2>
      </Reveal>

      <div className="mt-14 divide-y divide-[#0B3C5C]/10 border-y border-[#0B3C5C]/10">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.05} y={20}>
            <div
              data-testid={`service-row-${i + 1}`}
              className="group grid grid-cols-1 items-start gap-4 py-8 transition-all duration-300 hover:bg-[#0B3C5C]/[0.03] sm:grid-cols-12 sm:items-center sm:gap-8 sm:px-4"
            >
              <span className="font-mono-x text-sm font-medium text-amber-500 sm:col-span-1">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="font-display text-lg font-bold text-[#0B3C5C] transition-colors duration-300 group-hover:text-[#5FA832] sm:col-span-4 sm:text-xl">
                {s.title}
              </h3>
              <p className="text-sm leading-relaxed text-[#4A6B82] sm:col-span-5">{s.desc}</p>
              <div className="sm:col-span-2 sm:text-right">
                <a
                  href="#enquiry"
                  data-testid={`service-cta-${i + 1}`}
                  className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.15em] text-[#4C8F2F] transition-colors hover:text-[#5FA832]"
                >
                  {s.cta}
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
